"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NAVIGATION = void 0;
var NAVIGATION = {
  BUTTON__ACCOUNT_ACTIVITY: 'crmNavigation-button-accountActivity',
  BUTTON__TO_DOS: 'crmNavigation-button-toDos',
  BUTTON__TEAM_ACTIVITY: 'crmNavigation-button-teamActivity',
  BUTTON__EXPENSE_TRACKING: 'crmNavigation-button-expenseTracking'
};
exports.NAVIGATION = NAVIGATION;